module.exports = __webpack_public_path__ + "media/images/athletes/656-6ce77f0e428e7ead0bb1ff42b1068a63.png";